<!-- 由 suu 创建于 2025-10-14 星期二 -->
<template>
  <div class="SubSkeleton">
    <div class="skeleton-container">
      <div class="skeleton-date">
        <div
          class="top-item"
          :class="{ 'top-item-active': i == 1 }"
          v-for="i in 7"
          :key="i"
        ></div>
      </div>
      <div class="skeleton-se">
        <div class="se-item" v-for="i in 2" :key="i"></div>
      </div>
      <div class="skeleton-list">
        <div class="list-header"></div>
        <div class="list-item" v-for="i in 12" :key="i">
          <div class="list-item-left">
            <div class="list-item-left-img"></div>
            <div class="list-item-left-text">
              <div class="text-1"></div>
              <div class="text-2"></div>
              <div class="text-2"></div>
            </div>
          </div>
          <div class="list-item-right">
            <div class="list-item-right-num">
              <div class="num-top"></div>
              <div class="num-bottom"></div>
            </div>
            <div class="list-item-right-btn"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubSkeleton',

  components: {},

  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.SubSkeleton {
  width: 100vw;
  box-sizing: border-box;
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  .skeleton-container {
    width: 100%;
    box-sizing: border-box;
    padding: 18px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .skeleton-date {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .top-item {
        width: 28px;
        height: 36px;
        background: #ebebeb;
        border-radius: 2px;
        &.top-item-active {
          background: rgba($color: #f14d4d, $alpha: 0.1);
        }
      }
    }
    .skeleton-se {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 28px;
      .se-item {
        width: 167px;
        height: 36px;
        background: #ebebeb;
        border-radius: 4px;
      }
    }
    .skeleton-list {
      width: 100%;
      box-sizing: border-box;
      margin-top: 28px;
      .list-header {
        width: 166px;
        height: 13px;
        background: #ebebeb;
        border-radius: 4px;
      }
      .list-item {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 23px;
        .list-item-left {
          width: 100%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          .list-item-left-img {
            width: 68px;
            height: 68px;
            background: #ebebeb;
            border-radius: 50%;
            margin-right: 9px;
          }
          .list-item-left-text {
            .text-1 {
              width: 51px;
              height: 13px;
              background: #ebebeb;
              border-radius: 4px;
            }
            .text-2 {
              width: 128px;
              height: 13px;
              background: #ebebeb;
              border-radius: 4px;
              margin-top: 8px;
            }
          }
        }
        .list-item-right {
          display: flex;
          align-items: center;
          .list-item-right-num {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 18px;
            .num-top {
              width: 43px;
              height: 13px;
              background: #ebebeb;
              border-radius: 4px;
            }
            .num-bottom {
              width: 23px;
              height: 29px;
              background: #ebebeb;
              border-radius: 4px;
              margin-top: 6px;
            }
          }
          .list-item-right-btn {
            width: 28px;
            height: 16px;
            background: rgba($color: #f14d4d, $alpha: 0.1);
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>
